/* eslint-disable func-names */
import Choices from 'choices.js';

import BaseModule from '../../../../javascripts/helpers/baseModule';

class Select extends BaseModule {
  constructor(element) {
    super(element, 'a-select');

    this.getElements([
      {
        id: 'select',
        selector: 'select'
      }
    ]);

    const {
      searchPlaceholderValue,
      noResultsText,
      itemSelectText,
      searchEnabled,
      shouldSort,
      placeholder
    } = this.elements.select.dataset;

    new Choices(this.elements.select, {
      noResultsText,
      itemSelectText,
      searchEnabled: searchEnabled === 'true',
      shouldSort: shouldSort === 'true',
      removeItemButton: true,
      searchPlaceholderValue,
      placeholder: placeholder === 'true',
      noChoicesText: 'Keine weitere Auswahl möglich'
    });

    this.elements.select.addEventListener(
      'change',
      function(event) {
        if (event.detail.value && event.detail.value !== '-1') {
          // Open value as URL in browser if element has a specific class
          if (element.classList.contains('a-select--open-url-on-change')) {
            window.location.href = event.detail.value;
          }
        }
      },
      false
    );
  }
}

export default Select;
